// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.main-content {
    flex: 1 1;
    padding: 6px;
    display: flex;
    flex-direction: column;
}

.params-fields {
    display: flex;
    justify-content: space-between;
    max-width: 800px;
    margin: 0 ;
}


.loader-overlay {
    position: fixed;          /* Stay in a fixed position (like a modal) */
    background-color: rgba(0, 0, 0, 0.5);  /* Add transparency */           /* Use flexbox to center the loader */ /* Horizontally center */     /* Vertically center */
    z-index: 9999;           /* Make sure it's above other elements */
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.8);
  }
  



pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    margin: 0;
}

.api-name {
    padding: 10px 15px;
    font-size: 12px;
}

.fields-container {
    margin-bottom: 0;
}

.field-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.field-row input {
    flex: 1 1;
    padding: 4px 5px;
    border: 1px solid #ddd;
    border-radius: 3px;
}

.add-button,
.remove-button,
.submit-button {
    padding: 4px 8px;
    background-color: #0e3450;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    transition: background-color 0.3s;
}

.add-button:hover,
.remove-button:hover,
.submit-button:hover {
    background-color: #1aa891;
}

.submit-button {
    margin: 2px;
}



  `, "",{"version":3,"sources":["webpack://./src/app-2/components/MainContent/MainContent.css"],"names":[],"mappings":";AACA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;AACd;;;AAGA;IACI,eAAe,WAAW,4CAA4C;IAKtE,oCAAoC,GAAG,qBAAqB,YACnC,qCAAqC,EACrC,wBAAwB,MACxB,sBAAsB;IAC/C,aAAa,YAAY,wCAAwC;IAIjE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,oCAAoC;EAXtC;;;;;AAiBF;IACI,qBAAqB;IACrB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;;IAGI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf","sourcesContent":["\n.main-content {\n    flex: 1;\n    padding: 6px;\n    display: flex;\n    flex-direction: column;\n}\n\n.params-fields {\n    display: flex;\n    justify-content: space-between;\n    max-width: 800px;\n    margin: 0 ;\n}\n\n\n.loader-overlay {\n    position: fixed;          /* Stay in a fixed position (like a modal) */\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);  /* Add transparency */\n    display: flex;           /* Use flexbox to center the loader */\n    justify-content: center; /* Horizontally center */\n    align-items: center;     /* Vertically center */\n    z-index: 9999;           /* Make sure it's above other elements */\n  }\n\n  .loader-overlay {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: rgba(255, 255, 255, 0.8);\n  }\n  \n\n\n\npre {\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    margin: 0;\n}\n\n.api-name {\n    padding: 10px 15px;\n    font-size: 12px;\n}\n\n.fields-container {\n    margin-bottom: 0;\n}\n\n.field-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.field-row input {\n    flex: 1;\n    padding: 4px 5px;\n    border: 1px solid #ddd;\n    border-radius: 3px;\n}\n\n.add-button,\n.remove-button,\n.submit-button {\n    padding: 4px 8px;\n    background-color: #0e3450;\n    color: white;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: bold;\n    transition: background-color 0.3s;\n}\n\n.add-button:hover,\n.remove-button:hover,\n.submit-button:hover {\n    background-color: #1aa891;\n}\n\n.submit-button {\n    margin: 2px;\n}\n\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
